import { Typography } from '@mui/material';

export const LargePageLineText = ({ children, style, ...props }: any) => {
  return (
    <Typography
      style={{
        display: 'flex',
        zIndex: 10,
        marginTop: '-7px',
        marginLeft: '-13px',
        fontSize: 40,
        position: 'absolute',
        background: 'transparent',
        border: 'none',
        fontFamily: 'Futura-Light',
        color: '#000',
        ...style
      }}
      {...props}
    >
      {children}
    </Typography>
  );
};

export const SmallPageLineText = ({ children, isNarrow, style, ...props }: any) => {
  return (
    <Typography
      style={{
        display: 'flex',
        zIndex: 10,
        fontSize: isNarrow ? 20 : 24,
        position: 'absolute',
        background: 'transparent',
        border: 'none',
        fontFamily: 'Futura-Light',
        fontWeight: 'bolder',
        marginLeft: '-12px',
        marginTop: '-4px',
        paddingRight: '10px',
        color: '#000',
        ...style
      }}
      {...props}
    >
      {children}
    </Typography>
  );
};
